// src/api/contractUserClient.js
// 일반 사용자(아르바이트생) 전용 API 호출 — 관리자 로그인과 별도의 토큰을 사용합니다.

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const TOKEN_KEY = 'hub_contract_user_token';
const NAME_KEY = 'hub_contract_user_name';

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setToken(token, employeeName) {
  sessionStorage.setItem(TOKEN_KEY, token);
  if (employeeName) sessionStorage.setItem(NAME_KEY, employeeName);
}

export function getEmployeeName() {
  return sessionStorage.getItem(NAME_KEY) || '';
}

export function clearToken() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(NAME_KEY);
}

export function isLoggedIn() {
  return !!getToken();
}

async function handleResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (res.status === 401) {
    clearToken();
    window.location.href = '/my/login';
    throw new Error(data.error || '로그인이 필요합니다.');
  }
  if (!res.ok) {
    throw new Error(data.error || `요청 실패 (status: ${res.status})`);
  }
  return data;
}

function authHeaders(extra = {}) {
  const token = getToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : extra;
}

export const contractUserApi = {
  // 로그인 가능한(사용 상태 + 기간 안 지난) 행사 목록 — 인증 불필요, 로그인 화면에서 사용
  getAvailableEvents: () =>
    fetch(`${API_BASE}/events/available`).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || '행사 목록을 불러오지 못했습니다.');
      return data;
    }),

  // 로그인: 행사(eventId) + 휴대폰번호(phone) + 비밀번호(password)
  login: (eventId, phone, password) =>
    fetch(`${API_BASE}/contract-auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventId, phone, password }),
    }).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || '로그인에 실패했습니다.');
      return data;
    }),

  get: (path) =>
    fetch(`${API_BASE}${path}`, { headers: authHeaders() }).then(handleResponse),

  post: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    }).then(handleResponse),

  // PDF 다운로드용 URL (토큰을 쿼리스트링에 포함)
  fileUrl: (path) => `${API_BASE}${path}${path.includes('?') ? '&' : '?'}token=${getToken()}`,
};

export default contractUserApi;
